import React, { useMemo } from "react";
import { v4 } from "uuid";
import styled from "styled-components";

import { colors } from "@trailhead/asurion-ui";

import { StarIcon } from "../../assets";

interface RatingStarProps {
  hoverRating: number;
  rating: number;
  index: number;
  setHoverRating: CallableFunction;
  setRating: CallableFunction;
  onSubmit: CallableFunction;
}

const StarContainer = styled.div`
  cursor: pointer;
`;

export const RatingStar = ({
  hoverRating,
  rating,
  index = -1,
  setHoverRating,
  setRating,
  onSubmit,
}: RatingStarProps) => {
  const svgUuid = v4();

  const svgProps = useMemo(
    () =>
      hoverRating >= index || (!hoverRating && rating >= index)
        ? { fill: colors.warningBright, stroke: "#8A5300" }
        : { fill: colors.neutralBrightest, stroke: colors.neutralDeeper },
    [rating, hoverRating, index],
  );

  const onMouseEnter = (idx: number) => {
    setHoverRating(idx);
  };

  const onMouseLeave = () => {
    setHoverRating(0);
  };

  const onSaveRating = (idx: number) => {
    setRating(idx);
    onSubmit(idx);
  };

  return (
    <StarContainer
      className="cursor-pointer"
      onMouseEnter={() => onMouseEnter(index)}
      onMouseLeave={() => onMouseLeave()}
      onClick={() => onSaveRating(index)}
    >
      <StarIcon {...svgProps} uuid={svgUuid} />
    </StarContainer>
  );
};
